var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 2L0 2","stroke":"black","strokeWidth":"3","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"30","height":"4","viewBox":"0 0 30 4","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
